import Model from '@models/model'
import commonReducers from '@src/models/commonReducers'
import { FETCH_LEGAL_POLICY_CONSENT_STATUSES } from '../graphql/legalPolicyConsentStatuses'
import { ACCEPT_LEGAL_POLICY } from '../graphql/acceptLegalPolicy'
import { PolicyConsentsStoreState } from '../types'

export default class PolicyConsents {
  namespace = 'policyConsents'

  state: PolicyConsentsStoreState = {
    ...Model.defaultState,
    statuses: [],
  }

  effects = {
    statuses: Model.buildEffect({
      name: `${this.namespace}/statuses`,
      query: FETCH_LEGAL_POLICY_CONSENT_STATUSES,
      dataPath: 'legalPolicyConsentStatuses',
      reducers: [{ name: 'fetchList', dataPath: 'statuses', storePath: 'statuses' }],
    }),
    accept: Model.buildEffect({
      name: `${this.namespace}/accept`,
      query: ACCEPT_LEGAL_POLICY,
      dataPath: 'acceptLegalPolicy',
    }),
  }

  reducers = {
    ...Model.defaultReducers,
    fetchList: commonReducers.fetchList,
  }
}
